import { assertNever } from '@kofno/piper';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { Link } from '../../../../../../../../../Resource/Types';
import { NotTranslated, T } from '../../../../../../../../../Translations';
import FlashMessage from '../../../../../../../../FlashMessage';
import {
  filterGroups,
  filterParticipants,
  selectedParticipantCount,
} from '../../../../../../Functions';
import ParticipantDynamicTypeaheadSelect from '../../../../../../ParticipantDynamicTypeaheadSelect';
import {
  FilterOption,
  OptionType,
} from '../../../../../../ParticipantDynamicTypeaheadSelect/UseParticipantDynamicTypeaheadSelect/Types';
import InviteParticipantStore from '../../../Store';
import { SelectParticipantsState } from '../../../Types';
import ParticipantsList from './ParticipantsList';

export interface Props {
  link: Link;
  store: InviteParticipantStore;
  state: SelectParticipantsState;
}

const onChange = (store: InviteParticipantStore) => (option: FilterOption) => {
  option.payload.type.map((type: OptionType) => {
    switch (type) {
      case 'participant':
        store.addParticipant(option);
        break;
      case 'group':
        store.addGroup(option);
        break;
      default:
        assertNever(type);
    }
  });
};

function Body({ link, store, state }: Props) {
  const count = selectedParticipantCount(
    filterGroups(state.newGroupsAndParticipants),
    filterParticipants(state.newGroupsAndParticipants),
  );
  return (
    <>
      {store.notification.map((alert) => <FlashMessage alert={alert} />).getOrElse(emptyFragment)}
      <label className="py-1.5 text-sm font-semibold text-gray-800 block">
        <T kind="Program" />
      </label>
      <div className="flex flex-col mb-2">
        <select
          className="w-full bg-none rounded border-[#BEC0C580] bg-[#BEC0C580] opacity-50"
          disabled
          value={state.shareUrl.name.text}
        >
          <option value={state.shareUrl.name.text}>
            <NotTranslated text={state.shareUrl.name.text} />
          </option>
        </select>
      </div>
      <ParticipantDynamicTypeaheadSelect
        newGroups={filterGroups(state.newGroupsAndParticipants)}
        newParticipants={filterParticipants(state.newGroupsAndParticipants)}
        endpoint={link}
        name="participants"
        label="Select Participants or Groups"
        onChange={onChange(store)}
        initialValue={nothing()}
        labelClassname="py-1.5 text-sm font-semibold text-gray-800 block"
        placeholder="Enter Participant Name, Email or Group Name"
      />
      <div>
        <div className="font-semibold text-sm pt-4">
          <T kind="Participants to be added ({{count}} selected)" count={count} />
        </div>
      </div>
      <ParticipantsList store={store} state={state} />
    </>
  );
}

export default observer(Body);
